import { get, put, post, patch } from "./api_helper"

export const getPaymentMethods = () => get("admin/order/payment-method")

export const shipOrderApi = (id) => patch(`admin/order/${id}/shipping`);

export const getInspectionHistoryApi = (id) => get(`admin/order/${id}/inspection-history`)
